import { View } from "@react-pdf/renderer";

const TopMargin: React.FC = () => {
  return <View style={{ height: 40 }} />;
};

export default TopMargin;
